import styled from '@emotion/styled';
const StyledForm = styled.form`
    display: flex;
    flex-direction: row;
    gap: 24px;
    margin-block: 24px;
    padding: 20px;
    flex-wrap: wrap;
    justify-content: center;
    background: #f8f9fa;
    align-items: center;
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    transition: all 0.2s ease-in-out;
    margin-bottom: 32px;

    button {
        width: 100%;
        max-width: 200px;
        height: 44px;
    }

    .input {
        width: 200px;
        margin-bottom: 0 !important;
    }

    .MuiFormControl-root {
        margin-bottom: 0;
    }

    &:hover {
        box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    }
`;

export default StyledForm;
